import * as React from "react";
const SvgCode = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 20, viewBox: "0 -960 960 960", width: 20, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M336-240 96-480l240-240 51 51-189 189 189 189-51 51Zm288 0-51-51 189-189-189-189 51-51 240 240-240 240Z" }));
export default SvgCode;
